import { ActionTypes } from "../../../constants/ActionConstants";

export const openTabContentPreviewForm = () => ({
  type: ActionTypes.TabContentPreviewForm.OPEN_TAB_CONTENT_PREVIEW_MODAL,
});

export const closeTabContentPreviewForm = () => ({
  type: ActionTypes.TabContentPreviewForm.CLOSE_TAB_CONTENT_PREVIEW_MODAL,
});
